import { useCallback } from 'react'

import { useFileUploadContext } from './useFileUploadContext'

export function useFileUploadInputState() {
    const {
        inputId,
        dropzoneId,
        labelId,
        disabled,
        accept,
        maxFiles,
        maxSize,
        multiple,
        name,
        required,
        onFilesChange,
    } = useFileUploadContext()

    const onChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const files = Array.from(event.target.files ?? [])
            onFilesChange(files)
            event.target.value = ''
        },
        [onFilesChange]
    )

    return {
        disabled,
        inputId,
        dropzoneId,
        labelId,
        onChange,
        accept,
        maxFiles,
        maxSize,
        multiple,
        name,
        required,
    }
}
